<script lang="ts">
import Vue from 'vue';
import { Event } from '@/models/Event';
import { getEventClasses } from '@/models/EventClass';
import { userIsStaff } from '@/helpers/auth';

export default Vue.extend({
    name: 'CompactViewEventClassSelection',
    props: {
        record: Event,
    },
    data() {
        return {
            eventClasses: getEventClasses(),
        };
    },
    methods: {
        userIsStaff,
        onInput(newVal: string | null, oldVal: string | null) {
            if (newVal !== oldVal) {
                this.$emit('propertyChange', { property: 'event_class', value: newVal });
            }
        },
    },
});
</script>

<template>
    <v-radio-group row :value="record.event_class" class="class-selection" @change="onInput">
        <template v-for="eventClass in eventClasses.models">
            <v-radio
                v-if="!eventClass.staffOnly || userIsStaff()"
                :key="eventClass.value"
                class="radio-equal"
                :value="eventClass.classValue"
                :label="eventClass.label"
                :ripple="false"
            >
            </v-radio>
        </template>
    </v-radio-group>
</template>

<style lang="scss" scoped>
.class-selection {
    margin-top: 5px !important;
}
.radio-equal {
    width: 45%;
}
</style>
